import { css } from '@emotion/react';
import { Colors } from '../common/Colors';

export const helperBgBlured = css`
  background-color: ${Colors.ut.bgDefault};

  @supports (backdrop-filter: blur(20px)) or (-webkit-backdrop-filter: blur(20px)) {
    backdrop-filter: saturate(180%) blur(20px);
    background-color: rgba(255, 255, 255, 0.75);
  }
`;
